var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStyleToggleIconSingle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1204_177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.66667 4.75C5.42355 4.75 5.19039 4.84658 5.01849 5.01849C4.84658 5.19039 4.75 5.42355 4.75 5.66667V8.62567C4.75 8.99034 4.60513 9.34008 4.34727 9.59794C4.08941 9.8558 3.73967 10.0007 3.375 10.0007C3.01033 10.0007 2.66059 9.8558 2.40273 9.59794C2.14487 9.34008 2 8.99034 2 8.62567V5.66667C2 4.69421 2.38631 3.76157 3.07394 3.07394C3.76157 2.38631 4.69421 2 5.66667 2H8.62567C8.99034 2 9.34008 2.14487 9.59794 2.40273C9.8558 2.66059 10.0007 3.01033 10.0007 3.375C10.0007 3.73967 9.8558 4.08941 9.59794 4.34727C9.34008 4.60513 8.99034 4.75 8.62567 4.75H5.66667ZM15.9993 3.375C15.9993 3.01033 16.1442 2.66059 16.4021 2.40273C16.6599 2.14487 17.0097 2 17.3743 2H20.3333C21.3058 2 22.2384 2.38631 22.9261 3.07394C23.6137 3.76157 24 4.69421 24 5.66667V8.62567C24 8.99034 23.8551 9.34008 23.5973 9.59794C23.3394 9.8558 22.9897 10.0007 22.625 10.0007C22.2603 10.0007 21.9106 9.8558 21.6527 9.59794C21.3949 9.34008 21.25 8.99034 21.25 8.62567V5.66667C21.25 5.42355 21.1534 5.19039 20.9815 5.01849C20.8096 4.84658 20.5764 4.75 20.3333 4.75H17.3743C17.0097 4.75 16.6599 4.60513 16.4021 4.34727C16.1442 4.08941 15.9993 3.73967 15.9993 3.375ZM3.375 15.9993C3.73967 15.9993 4.08941 16.1442 4.34727 16.4021C4.60513 16.6599 4.75 17.0097 4.75 17.3743V20.3333C4.75 20.5764 4.84658 20.8096 5.01849 20.9815C5.19039 21.1534 5.42355 21.25 5.66667 21.25H8.62567C8.99034 21.25 9.34008 21.3949 9.59794 21.6527C9.8558 21.9106 10.0007 22.2603 10.0007 22.625C10.0007 22.9897 9.8558 23.3394 9.59794 23.5973C9.34008 23.8551 8.99034 24 8.62567 24H5.66667C4.69421 24 3.76157 23.6137 3.07394 22.9261C2.38631 22.2384 2 21.3058 2 20.3333V17.3743C2 17.0097 2.14487 16.6599 2.40273 16.4021C2.66059 16.1442 3.01033 15.9993 3.375 15.9993ZM22.625 15.9993C22.9897 15.9993 23.3394 16.1442 23.5973 16.4021C23.8551 16.6599 24 17.0097 24 17.3743V20.3333C24 21.3058 23.6137 22.2384 22.9261 22.9261C22.2384 23.6137 21.3058 24 20.3333 24H17.3743C17.0097 24 16.6599 23.8551 16.4021 23.5973C16.1442 23.3394 15.9993 22.9897 15.9993 22.625C15.9993 22.2603 16.1442 21.9106 16.4021 21.6527C16.6599 21.3949 17.0097 21.25 17.3743 21.25H20.3333C20.5764 21.25 20.8096 21.1534 20.9815 20.9815C21.1534 20.8096 21.25 20.5764 21.25 20.3333V17.3743C21.25 17.0097 21.3949 16.6599 21.6527 16.4021C21.9106 16.1442 22.2603 15.9993 22.625 15.9993Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1204_177",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1204_177"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1204_177",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStyleToggleIconSingle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/styleToggle_icon_single.2356df1c.svg";
export { ForwardRef as ReactComponent };